export const designSystemRoutes = {
  home: 'design/system'
};
